import { FormikHandlers } from 'formik'
import React, { Ref } from 'react'

interface InputGroupProps {
  additionalContainerClasses?: string
  additionalLabelClasses?: string
  disabled?: boolean
  error?: string
  font?: string
  hideLabel?: boolean
  hideError?: boolean
  inputFontSize?: string
  label: string
  labelTextSize?: string
  min?: string | number
  max?: string | number
  maxLength?: number
  placeholder: string
  restrictError?: boolean
  touched?: boolean
  type?: string
  value: string | number
  width?: string
  required?: boolean
  name?: string
  id?: string
  readOnly?: boolean
  handleBlur: FormikHandlers['handleBlur']
  handleChange: FormikHandlers['handleChange']
}
const InputGroup = React.forwardRef(
  (
    {
      additionalContainerClasses = '',
      additionalLabelClasses = '',
      error,
      disabled = false,
      font = 'font-ttHovesMedium',
      hideLabel = false,
      hideError = false,
      inputFontSize = 'text-sm',
      label,
      labelTextSize = 'text-sm',
      min = undefined,
      max = undefined,
      maxLength = undefined,
      placeholder,
      touched,
      type = 'text',
      value,
      width = 'w-full',
      required,
      name,
      id,
      readOnly,
      handleBlur,
      handleChange,
    }: InputGroupProps,
    ref: Ref<HTMLInputElement>
  ) => {
    const hasError = Boolean(touched && error)

    return (
      <div
        className={`flex relative flex-col mb-2 ${additionalContainerClasses} ${width}`}
      >
        {!hideLabel && (
          <label
            htmlFor={id ? id : undefined}
            className={`text-green-100 ${labelTextSize} mb-[7px] ${font} ${additionalLabelClasses}`}
          >
            {label} {required && <span className="">*</span>}
          </label>
        )}
        <input
          ref={ref ? ref : undefined}
          aria-describedby={id ? `${id}_hint` : undefined}
          aria-invalid={hasError ? 'true' : 'false'}
          className={`rounded-[4px] border ${
            hasError
              ? 'border-red-brand focus:ring-red-brand'
              : 'border-[#BDBDBD] focus:ring-nptDGreen'
          } focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-300 ${inputFontSize} disabled:bg-gray-100`}
          disabled={disabled}
          id={id ? id : undefined}
          min={min}
          max={max}
          maxLength={maxLength}
          name={name ? name : undefined}
          onBlur={handleBlur}
          onChange={handleChange}
          placeholder={placeholder}
          type={type}
          value={value}
          readOnly={readOnly}
        />

        {hasError && (
          <p
            id={id ? `${id}_hint` : undefined}
            className={[
              error ? 'opacity-100' : 'hidden opacity-0',
              'absolute top-full left-0 mt-1 max-w-[475px] text-xs text-red-brand',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {error}
          </p>
        )}
      </div>
    )
  }
)

export default InputGroup

InputGroup.displayName = 'InputGroup'
